<template>
  <div>
    <div
      class="md-layout-item md-size-100"
      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                    "
    >
      Hotel occupancy
      <ValidationProvider name="Hotel occupancy" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
        <div class="occupancy">
          <md-radio v-model="value.condition.total_room_occupancy_format" value="PERCENTAGE">% occ</md-radio>
          <md-radio v-model="value.condition.total_room_occupancy_format" value="ABSOLUTE">rooms</md-radio>
          <span class="radio-error" :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      between
      <ValidationProvider name="min" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
        <md-field
          style="display: inline-flex"
          class="md-field md-layout-item md-size-20 md-theme-default"
          :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
        >
          <label>min</label>
          <md-input v-model="value.condition.total_room_occupancy_sold_from" />
          <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
        </md-field>
      </ValidationProvider>
      and
      <ValidationProvider name="max" :rules="'required'" v-slot="{ passed, failed, errors }" slim>
        <md-field
          style="display: inline-flex"
          class="md-field md-layout-item md-size-20 md-theme-default"
          :class="[{ 'md-error': failed }, { 'md-invalid': failed }, { 'md-valid': passed }]"
        >
          <label>max</label>
          <md-input v-model="value.condition.total_room_occupancy_sold_to" />
          <span :class="[{ 'md-error': failed }]">{{ errors[0] }}</span>
        </md-field>
      </ValidationProvider>
    </div>

    <div class="md-layout pricing-rule">
      <md-field class="md-layout-item md-size-20">
        <label for="movie">Applicable to</label>
        <md-select v-model="value.condition.applicable_to">
          <md-option value="ALL" selected>All</md-option>
          <md-option value="ROOM">Room price</md-option>
          <md-option value="BOARD">Board price</md-option>
        </md-select>
      </md-field>
    </div>
    <div class="md-layout pricing-rule">
      <rate-select
        multiple
        v-model="value.action.rate_ids"
        class="md-layout-item md-size-20 md-small-size-50"
        :show-bar="false"
      ></rate-select>
      <span>Than BAR</span>
      <md-field class="md-layout-item md-size-10 md-small-size-50">
        <label>increments</label>
        <md-input v-model.number="value.action.delta"></md-input>
      </md-field>
      <div>
        <span>%</span>
      </div>
      <div class="md-layout-item md-size-100">
        <channel-select multiple v-model="value.channel_ids" :online="true" class="md-layout-item md-size-20"></channel-select>
      </div>
    </div>
  </div>
</template>

<script>
import ChannelSelect from '../../Inputs/ChannelSelect.vue'
import RateSelect from '../../Inputs/RateSelect.vue'
import Currency from '@/utils/Currency'

let currency

export default {
  name: 'RatesPricingRule',
  components: { RateSelect, ChannelSelect },
  props: {
    value: Object,
  },
  created() {
    this.currency = Currency[sessionStorage.getItem('currency')]
  },
  mounted() {
    this.value.action.percent = true
  },
}
</script>
<style scoped lang="scss">
.md-layout-item.md-size-100 {
  padding-left: 0;
}
.occupancy {
  position: relative;
  display: inline-flex;

  .radio-error {
    height: 20px;
    position: absolute;
    bottom: -22px;
    color: #ff1744;
    font-size: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
</style>
